module.exports = require('./helpers/bundle-url').getBundleURL('88FtB') + "zusam_logo.1eebfd28.svg";